import { compactHeaderStyles as styles } from "@insite/content-library/Pages/CompactHeader";
import { css } from "styled-components";

styles.mainNavigationWrapper = {
    ...styles.mainNavigationWrapper,
    css: css`
        ${styles.mainNavigationWrapper?.css}
        justify-content: flex-start;
        padding-left: 24px;

        & > div {
            & > div {
                height: 100%;
                .container {
                    height: 100%;
                    align-items: center;
                    .item-wrapper {
                        nav {
                            button,
                            span {
                                height: 100%;
                                margin-top: 0;
                                min-height: 50px;

                                & + span {
                                    top: 50%;
                                    transform: translateY(-50%);
                                }
                            }
                        }

                        a.menu-item {
                            height: 100%;
                            min-height: 50px;
                            margin-top: -3px;
                        }
                    }
                }
            }
        }
    `,
};
